// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"d960db04","231":"844aebc8","266":"37d393d9","525":"1fe68074","533":"ff1fab2a","832":"ab4d52a8"}[chunkId] + ".chunk.js";
};